// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page404_wrapper__2MyrB"};